import { TextField } from './TextField';
import { BoardSourceField } from './BoardSourceField';
import { HeadlineField } from './HeadlineField';
import { TextareaField } from './TextareaField';
import { ColumnSettingsField } from './ColumnSettingsField';
import { BoardFiltersField } from './BoardFiltersField';
import { BoardColumnField } from './BoardColumnField';
import { SelectField } from './SelectField';
import { SubitemsField } from './SubitemsField';
import { ItemActionsField } from './ItemActionsField';
import { ItemCommentsField } from './ItemCommentsField';
import { ItemSearchField } from './ItemSearchField';
import { DisableAutoFetchField } from './DisableAutoFetchField';
import { ItemsPerPageField } from './ItemsPerPageField';
import { TeasersField } from './TeasersField';
import { KeyFiguresField } from './KeyFiguresField';
import { DetailViewField } from './DetailViewField';
import { HideReloadButtonField } from './HideReloadButtonField';

export const fieldComponentsByType = {
  text: TextField,
  'board-source': BoardSourceField,
  headline: HeadlineField,
  textarea: TextareaField,
  'column-settings': ColumnSettingsField,
  'board-filters': BoardFiltersField,
  'board-column': BoardColumnField,
  select: SelectField,
  subitems: SubitemsField,
  'item-actions': ItemActionsField,
  'items-per-page': ItemsPerPageField,
  'item-comments': ItemCommentsField,
  'item-search': ItemSearchField,
  'disable-auto-fetch': DisableAutoFetchField,
  'hide-reload-button': HideReloadButtonField,
  'detail-view': DetailViewField,
  teasers: TeasersField,
  'key-figures': KeyFiguresField,
};
